import React, { useEffect, useState } from "react";
import AsyncSelect from "react-select/async";
import axios from "axios";

const transformICHIResults = (entities = []) => {
  return entities.map((entity) => ({
    value: entity.id,
    label: entity.title?.replace(/<[^>]*>/g, "") || "Untitled",
    code: entity.theCode,
    full: entity,
  }));
};

const ICHISelect = ({ onSelect, description }) => {
  const [defaultOptions, setDefaultOptions] = useState([]);
  const [defaultValue, setDefaultValue] = useState(null);

  const loadOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 3) return [];

    const formData = new FormData();
    formData.append("q", inputValue);
    formData.append(
      "chapterFilter",
      "10;11;12;13;14;15;16;17;18;19;20;21;22;23;24;25;01;02;03;04;05;06;07;08;09;"
    );
    formData.append("subtreesFilter", "http://id.who.int/icd/entity/289140506");
    formData.append("includePostcoordination", "true");
    formData.append("useBroaderSynonyms", "false");
    formData.append("useFlexiSearch", "false");
    formData.append("includeKeywordResult", "true");
    formData.append("flatResults", "true");
    formData.append("highlightingEnabled", "true");
    formData.append("medicalCodingMode", "true");

    try {
      const response = await axios.post(
        "https://icdapilive.azurewebsites.net/icd/release/11/beta/ichi/search",
        formData,
        {
          headers: {
            "accept-language": "en",
            "api-version": "v2",
          },
        }
      );

      const entities = response.data.destinationEntities || [];
      return transformICHIResults(entities);
    } catch (error) {
      console.error("ICHI Search Error:", error);
      return [];
    }
  };

  // Load default options on mount or when description changes
  useEffect(() => {
    if (description && description.length >= 3) {
      loadOptions(description).then((options) => {
        setDefaultOptions(options);
        if (options.length > 0) {
          setDefaultValue(options[0]);
          onSelect?.(options[0]); // auto-select first result
        }
      });
    }
  }, [description]);

  return (
    <AsyncSelect
      cacheOptions
      loadOptions={loadOptions}
      onChange={(selected) => {
        setDefaultValue(selected);
        onSelect?.(selected);
      }}
      placeholder="Search ICHI by procedure..."
      isClearable
      defaultOptions={defaultOptions}
      value={defaultValue}
    />
  );
};

export default ICHISelect;
